var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12,
    fill: "url(#pattern0_641_456)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_641_456",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_641_456",
    transform: "matrix(0.03125 0 0 0.0338542 0 -0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_641_456",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAArJJREFUWIXtl7FPE2EYxn/vUYskgIkUvUpbAssN1c0Q1EUX40YXjeL/wCjGxMQYE4Mr/wIy6MJonJxAcNM04SYiV2gRXNCEWGlfB3rluF6vei3i4DO997zfm+dp3+97vzs4YUgQmUhYfad6mFLkImhXmxIVhU+VPZ3d2bG//YaB6zEzXVwCLrcn3ICVkpO8Bu/2vaThX3Uhszl+DOIAY+eGS2N+MuYnqkjS81gB3gLfI4r2AjeBLgBDdailAS8EnhQd+1lEcQDMtPUYeNos39ACL1Sw2xEHQFgNS4ca+Bv4byB8D6i2bVA1fJC1EJC7iYTVF1U8kbD6BLkXtqbVMczFetg101ZUDy1x4nsg9B8AHOB9LR4H0qIsqrAhEFe4BSDwRqEsypAKV4PqIhlQlYdbhdV5gGTKuq/C3NkzsRv5fL4MkExbCwBFx84BZLPZ+Nfd/R9Bdc00Qlsghv6smzEoA7jiAAplhfqzmwuqi2SAKiP++PywNQIHvxYhJcpQNpuNe3NBdc3Q8D5gZqzbKK9CjUWFcKe0br/2UuF7ABZEmAdQZVIghzKNwZpUiavwHFBRHqlBmSojCDOBdU0QPgeEedexmbFAyZUK9gs3b6atCYBiwX7p4WaC6ppp/NtzQJVJM2PVYwHMlPWg3oKDM35w1NwWdNJAree5WuySMyioZ/uqMIfS5B07HOEtUKZLji0lxxaUaQA1GC05tgz0x7oRlkRZHOiPdZccW9RgtLMGDNb88dZnew1qQ0cpqLDhDiA31zEDUiXuj92hAyAQFw7XuLmguqYafsI3iP7oMkJIoVwJqquptR5EBmxWDx/T+G6y2m2HejmY4CjZUAdQrUghQO8oNteTy8CKn28fsvxlw/zQwAYtHRzM9hqnK1MClzrycSp8rO51zW5v56N+YR0ffgHh7RBmx4Iv3QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitCalculator);
export default __webpack_public_path__ + "static/media/profit_calculator.b2439b5b794ca9906ff078ddf2edb0d8.svg";
export { ForwardRef as ReactComponent };